import { useTranslation } from 'react-i18next';
import { SidebarLayoutHeader } from '~/layout/components/sidebar-layout-header/SidebarLayoutHeader';
import { StandardHeader } from '~/layout/components/standard-header/StandardHeader';

export interface LogMealHeaderProps {
  currentDate: Date;
  onDateChange: (date: Date) => void;
}

/**
 * Desktop header for the Log Meal screen — same chrome as every other desktop
 * header (sidebar header + subtitle/title + date pill). Hidden on mobile via
 * {@link SidebarLayoutHeader}; mobile uses the compact PageHeader instead.
 */
export const LogMealHeader = ({
  currentDate,
  onDateChange,
}: LogMealHeaderProps) => {
  const { t } = useTranslation('meal');

  return (
    <SidebarLayoutHeader>
      <StandardHeader subtitle={t('logMealSubtitle')} title={t('logMeal')}>
        <StandardHeader.Date
          currentDate={currentDate}
          onDateChange={onDateChange}
        />
      </StandardHeader>
    </SidebarLayoutHeader>
  );
};
